<template>
  <v-dialog
    v-model="show"
    max-width="700"
    overlay-color="darktext"
    overlay-opacity="0.6"
    disabled
  >
    <v-card v-if="participant" class="elevation-2 pa-5 pt-2">
      <v-row>
        <v-col align="right">
          <v-icon
            ref="cancel"
            data-testid="cancel-button"
            min-width="100"
            class="rounded-xxl text-none"
            style="z-index: 1"
            @click="show = false"
          >
            mdi-close
          </v-icon>
        </v-col>
      </v-row>

      <div
        class="text-h5 font-weight-bold darktext--text wrap-text mb-4 pl-3 text-uppercase"
        data-testid="profile-name"
      >
        {{ participant.first_name }} {{ participant.last_name }}
      </div>
      <v-col cols="12" md="12" class="pr-5 d-flex">
        <p class="text-body-1 grey--text wrap-text">
          <label min-width="100px" class="black--text"
            >{{ $t("labelEmail") }}:
          </label>
          {{ participant.email }}
        </p>
      </v-col>
      <template v-if="participant_attributes">
        <v-col
          v-if="participant_attributes.phone"
          cols="12"
          md="12"
          class="pr-5"
        >
          <p class="text-body-1 grey--text wrap-text">
            <label min-width="100px" class="black--text"
              >{{ $t("phone") }}: </label
            >{{ participant.phone }}
          </p>
        </v-col>

        <v-col
          v-if="participant_attributes.personal_number"
          cols="12"
          md="12"
          class="pr-5"
        >
          <p class="text-body-1 grey--text wrap-text">
            <label min-width="100px" class="black--text"
              >{{ $t("personal_number") }}: </label
            >{{ participant.personal_number }}
          </p>
        </v-col>
        <v-col
          v-if="participant_attributes.allergies"
          cols="12"
          md="12"
          class="pr-5"
        >
          <p class="text-body-1 grey--text wrap-text">
            <label min-width="100px" class="black--text"
              >{{ $t("allergies") }}: </label
            >{{ participant.allergies }}
          </p>
        </v-col>
        <v-col
          v-if="participant_attributes.open_comment"
          cols="12"
          md="12"
          class="pr-5"
        >
          <p class="text-body-1 grey--text wrap-text">
            <label min-width="100px" class="black--text"
              >{{ $t("open_comment") }}: </label
            >{{ participant.open_comment }}
          </p>
        </v-col>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "../plugins/i18n";

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: "",
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t("cancel"),
    },
    title: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    participant: {
      type: Object,
      default() {
        return {};
      },
    },
    participant_attributes: {
      type: Object
    },
  },
  components: {},
  mixins: [],
  data() {
    return {
      valid: true,
      spaceId: window.$cookies.get("space_id"),
      user: this.participant,
    };
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created() {},
  methods: {},
};
</script>
<style>
.wrap-text{
    overflow-wrap: break-word;
    max-width: 100%;
}
</style>